import "./QuizPreviewer.less";
import React from "react";
import __ from "../../i18n";
import Icon from "../../../bootstrap/components/icon/Icon";
import QuizPlayer from "../../players/quiz/QuizPlayer";
import Button from "../../../bootstrap/components/button/Button";
import {useHistory} from 'react-router-dom';
import routes from "../../routing/routes";

export default function QuizPreviewer({courseId, lessons, questionGroups, questions, close}) {
    const history = useHistory();

    const quizIds = lessons.map(lesson => lesson.quiz_id);

    const previewQuestionGroup = questionGroups.filter(questionGroup => quizIds.includes(questionGroup.quiz_id));

    const previewQuestionGroupIds = previewQuestionGroup.map(questionGroup => questionGroup.id);

    const previewQuestions = questions.filter(question => {
        return previewQuestionGroupIds.includes(question.group_id) || quizIds.includes(question.quiz_id);
    });

    return (
        <div className="quiz-previewer">
            <div className="heading">
                <h3 className="title">{__("Sample questions")}</h3>
                <button
                    type="button"
                    className="close-button"
                    onClick={() => close()}
                >
                    <Icon name="times" />
                </button>
            </div>
            <div className="body">
                <div className="section">
                    <Button
                        title={__('View more ::count(PLURAL, 1 1 question, ! :@ questions)',
                            {count: questions.length - previewQuestions.length}
                        )}
                        icon="question-circle"
                        onClick={() => history.push(routes.checkout.getUrl('course', courseId))}
                    />
                </div>
                <div className="section">
                    <QuizPlayer
                        questionGroups={previewQuestionGroup}
                        questions={previewQuestions}
                        onClose={close}
                    />
                </div>
            </div>
        </div>
    );
}
